import axios from 'axios';
import {BaseResponse} from "../BaseResponse";
import {SignUpRequest} from "../signup/signUp";

export async function updateMember(request: SignUpRequest) {
    const response = await axios.put<BaseResponse<boolean>>(`/member`, request)

    return response.data
}